module.exports = __webpack_public_path__ + "static/media/newtonx_logo@3x.20f69a70.png";